import { LoadableApp } from 'ui-seeker/core'
import { HD_SEARCHES, HD_BOOKINGS } from 'app/config'

const Searches = LoadableApp(import('./Searches'))
const Bookings = LoadableApp(import('./Bookings'))

const PageRoutes = [
    { path: HD_SEARCHES.path, component: Searches, needLogin: true, header: false },
    { path: HD_BOOKINGS.path, component: Bookings, needLogin: true, header: false },
]

export default PageRoutes